import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { InterviewEventSearchResponse } from '@core/search-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<InterviewEventSearchResponse>()('SearchInterviewEvents', {
    customActions: adapter => ({
      fetch: (
        state,
        payload: {
          query: string;
        },
      ) => adapter.markAsPending(state),
    }),
  });

const { fetch, fetchSuccess, fetchFailed } = actions;
const SearchInterviewEventsActions = { fetch, fetchSuccess, fetchFailed };

export {
  SearchInterviewEventsActions,
  selectors as SearchInterviewEventsSelectors,
  reducer as SearchInterviewEventsReducer,
  namespace as SearchInterviewEventsNamespace,
};
